var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 142.5,
    height: 156.576,
    viewBox: "0 0 142.5 156.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f08089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#efab4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#e1d159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#4694ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#576298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76578f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_23",
    "data-name": "Intersection 23",
    d: "M65.721,156.576a21.96,21.96,0,0,1-21.609-20.468h-.073V123.915a35.9,35.9,0,0,0-8.724-23.2,47.187,47.187,0,1,1,71.605.309,34.919,34.919,0,0,0-8.456,22.886v12.193h-.076a21.955,21.955,0,0,1-21.606,20.468Zm.263-3.5H76.519a18.466,18.466,0,0,0,18.358-16.687H47.626A18.464,18.464,0,0,0,65.984,153.073ZM47.544,132.6H94.959v-6.936H47.544Zm34.28-10.54H95.006a38.369,38.369,0,0,1,9.266-23.331A43.68,43.68,0,0,0,69.15,26.51C46.673,27.562,28.025,46.736,27.579,69.254a43.638,43.638,0,0,0,10.4,29.191,39.551,39.551,0,0,1,9.51,23.618H60.677V70.355H53.936a1.753,1.753,0,0,1,0-3.507h7.691a1.583,1.583,0,0,1,1.607,0H79.269a1.583,1.583,0,0,1,1.607,0h7.691a1.753,1.753,0,0,1,0,3.507H81.824Zm-17.642,0H78.319V70.355H64.182Zm54.974-2.142-11.1-11.1a1.752,1.752,0,1,1,2.478-2.478l11.1,11.1a1.752,1.752,0,0,1-2.478,2.478Zm-98.287,0a1.752,1.752,0,0,1,0-2.478l11.1-11.1a1.752,1.752,0,0,1,2.478,2.478l-11.1,11.1a1.754,1.754,0,0,1-2.478,0ZM125.052,71.292a1.752,1.752,0,1,1,0-3.5h15.7a1.75,1.75,0,0,1,1.751,1.68v.144a1.751,1.751,0,0,1-1.751,1.681Zm-123.3,0a1.752,1.752,0,1,1,0-3.5h15.7a1.752,1.752,0,1,1,0,3.5Zm106.3-38.556a1.755,1.755,0,0,1,0-2.478l11.1-11.1a1.752,1.752,0,1,1,2.478,2.478l-11.1,11.1a1.754,1.754,0,0,1-2.478,0Zm-76.084,0-11.1-11.1a1.752,1.752,0,1,1,2.478-2.478l11.1,11.1a1.752,1.752,0,0,1-2.478,2.478ZM69.5,17.451V1.754a1.752,1.752,0,1,1,3.5,0v15.7a1.752,1.752,0,1,1-3.5,0Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGain);
export default __webpack_public_path__ + "static/media/gain.c367cd04cec145650f17127c82fb3ac4.svg";
export { ForwardRef as ReactComponent };